import { Protocol } from '../Protocol';

export class DemandOrderProtocol {
  public static readonly DEMAND_ORDER: string = `${Protocol.YATUNG_API_ROOT}/req/V2`;
  public static readonly ALL_DEMAND_ORDER: string = `${Protocol.YATUNG_API_ROOT}/req/all`;
  public static readonly DEMAND_ORDER_BY_HOLDER: string = `${Protocol.YATUNG_API_ROOT}/req/holder`;
  public static readonly ALL_DEMAND_ITEM_DETAIL: string = `${Protocol.YATUNG_API_ROOT}/req/items/all`;
  public static readonly DEMAND_ORDER_LIST: string = `${Protocol.YATUNG_API_ROOT}/req/V2/view`;
}
